const namespace = "topPrize";

export const PRIZE = `${namespace}.prize`;
export const TICKET = `${namespace}.ticket`;
